import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-698b4b3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_language_switcher = _resolveComponent("language-switcher")!
  const _component_notification_list = _resolveComponent("notification-list")!
  const _component_the_navigation = _resolveComponent("the-navigation")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_language_switcher),
    _createVNode(_component_notification_list),
    _createVNode(_component_the_navigation),
    _createVNode(_component_router_view, {
      class: _normalizeClass(["root", _ctx.isNavOpen ? 'open' : ''])
    }, null, 8, ["class"])
  ]))
}